import styled from 'styled-components';
import { FieldLocation } from './FieldLocation';

export const FieldLocationStyled = styled(FieldLocation)`
  width: 12rem;
`;
